import { render, staticRenderFns } from "./center-area.vue?vue&type=template&id=0298fe5a&scoped=true&"
import script from "./center-area.vue?vue&type=script&lang=js&"
export * from "./center-area.vue?vue&type=script&lang=js&"
import style0 from "./center-area.vue?vue&type=style&index=0&id=0298fe5a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0298fe5a",
  null
  
)

export default component.exports